<section class="create">
  <div class="create_title">{{ data.title }}</div>
  <div cdkFocusInitial class="close-dialog" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </div>
  <mat-dialog-content>
    <div class="create_content">
      <form (ngSubmit)="onEgacCreateSubmit()" [formGroup]="egacCreateForm">
        <div class="row">
          <div class="col-sm-6 pr-sm-2">
            <mat-form-field appearance="outline" class="form-group">
                <mat-label>First Name (English)</mat-label>
                <input formControlName="firstName" matInput maxlength="40" />
                <mat-error *ngIf="hasError('firstName', 'required')">
                    Field is Required
                </mat-error>
                <mat-error *ngIf="egacCreateForm.get('firstName').errors?.whiteSpaceValidator">
                    Field is Required
                </mat-error>
                <mat-error *ngIf="hasError('firstName', 'pattern')">
                    Accept only Characters
                </mat-error>
                <mat-error *ngIf="egacCreateForm.get('firstName').errors?.serverError">
                    {{ egacCreateForm.get('firstName').errors?.serverError }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-sm-6 pl-sm-2">
            <mat-form-field appearance="outline" class="form-group">
                <mat-label>Last Name (English)</mat-label>
                <input formControlName="familyName" matInput maxlength="40" />
                <mat-error *ngIf="hasError('familyName', 'required')">
                    Field is Required
                </mat-error>
                <mat-error *ngIf="egacCreateForm.get('familyName').errors?.whiteSpaceValidator">
                    Field is Required
                </mat-error>
                <mat-error *ngIf="hasError('familyName', 'pattern')">
                    Accept only Characters
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-sm-6 pr-sm-2">
            <mat-form-field appearance="outline" class="form-group">
                <mat-label>First Name (Arabic)</mat-label>
                <input formControlName="user_first_name_ar" matInput maxlength="40" />
                <mat-error *ngIf="hasError('user_first_name_ar', 'required')">
                    Field is Required
                </mat-error>
                <mat-error *ngIf="egacCreateForm.get('user_first_name_ar').errors?.whiteSpaceValidator">
                    Field is Required
                </mat-error>
                <mat-error *ngIf="hasError('user_first_name_ar', 'pattern')">
                    Accept only Characters
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-sm-6 pl-sm-2">
            <mat-form-field appearance="outline" class="form-group">
                <mat-label>Last Name (Arabic)</mat-label>
                <input autocomplete="off" formControlName="user_last_name_ar" matInput maxlength="40" />
                <mat-error *ngIf="hasError('user_last_name_ar', 'required')">
                    Field is Required
                </mat-error>
                <mat-error *ngIf="egacCreateForm.get('user_last_name_ar').errors?.whiteSpaceValidator">
                    Field is Required
                </mat-error>
                <mat-error *ngIf="hasError('user_last_name_ar', 'pattern')">
                    Accept only Characters
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-12">
            <mat-form-field appearance="outline" class="form-group">
                <mat-label>Full Name (English)</mat-label>
                <input formControlName="user_full_name_en" matInput maxlength="80" />
                <mat-error *ngIf="hasError('user_full_name_en', 'required')">
                    Field is Required
                </mat-error>
                <mat-error *ngIf="egacCreateForm.get('user_full_name_en').errors?.whiteSpaceValidator">
                    Field is Required
                </mat-error>
                <mat-error *ngIf="hasError('user_full_name_en', 'pattern')">
                    Accept only Characters
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-sm-12">
            <mat-form-field appearance="outline" class="form-group">
                <mat-label>Full Name (Arabic)</mat-label>
                <input autocomplete="off" formControlName="user_full_name_ar" matInput maxlength="80" />
                <mat-error *ngIf="hasError('user_full_name_ar', 'required')">
                    Field is Required
                </mat-error>
                <mat-error *ngIf="egacCreateForm.get('user_full_name_ar').errors?.whiteSpaceValidator">
                    Field is Required
                </mat-error>
                <mat-error *ngIf="hasError('user_full_name_ar', 'pattern')">
                    Accept only Characters
                </mat-error>
            </mat-form-field>
        </div>
          <div [hidden]="data?.userType !== this.userTypeTokens.egacStaff" class="col-sm-12">
            <mat-form-field appearance="outline" class="form-group">
              <mat-label>Position</mat-label>
              <input
                [required]="data?.userType == this.userTypeTokens.egacStaff"
                formControlName="position"
                matInput
                maxlength="200"
              />
              <mat-error
                *ngIf="
                  egacCreateForm.get('position').errors?.whiteSpaceValidator
                "
              >
                Field is Required
              </mat-error>
              <mat-error *ngIf="hasError('position', 'required')">
                Field is Required
              </mat-error>
              <!-- <mat-error *ngIf="hasError('position', 'pattern')">
                Accept only Letters and Spaces
              </mat-error> -->
            </mat-form-field>
          </div>
          <div class="col-sm-12">
            <mat-form-field appearance="outline" class="form-group">
              <mat-label>Nationality</mat-label>
              <mat-select
                class="profile-inputs_c-grey-6"
                formControlName="nationality"
              >
                <mat-option
                  *ngFor="let item of countryCodes"
                  [value]="item.country_token"
                >{{ item.countryName }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="hasError('nationality', 'required')">
                Is Required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-12">
            <div class="form-group mb-4">
              <ngx-intl-tel-input
                [customPlaceholder]="'01xxxxxxxx'"
                [enableAutoCountrySelect]="true"
                [enablePlaceholder]="true"
                [maxLength]="40"
                [numberFormat]="PhoneNumberFormat.International"
                [phoneValidation]="true"
                [searchCountryField]="[
                  SearchCountryField.Iso2,
                  SearchCountryField.Name
                ]"
                [searchCountryFlag]="true"
                [selectFirstCountry]="false"
                [selectedCountryISO]="CountryISO.UnitedArabEmirates"
                [separateDialCode]="separateDialCode"
                formControlName="phone"
                name="phone"
                (keydown.space)="$event.preventDefault();"
              >
              </ngx-intl-tel-input>
              <mat-error
                *ngIf="
                  egacCreateForm.controls['phone'].touched &&
                  egacCreateForm.controls['phone'].invalid &&
                  !egacCreateForm.controls['phone'].pristine
                "
              >
                <div
                  *ngIf="egacCreateForm.controls['phone'].errors.required"
                  class="intl-validation"
                >
                  Field is required
                </div>
                <div
                  *ngIf="egacCreateForm.controls['phone'].errors &&
                  !egacCreateForm.controls['phone'].errors.required"
                  class="intl-validation"
                >
                  Enter valid number according selected country (10 ~ 40)
                </div>
              </mat-error>
            </div>
          </div>
          <div class="col-sm-12">
            <mat-form-field appearance="outline" class="form-group">
              <mat-label>Email</mat-label>
              <input
                formControlName="email"
                matInput
                maxlength="200"
                placeholder="pat@example.com"
                (keydown.space)="$event.preventDefault();"
              />
              <mat-error *ngIf="hasError('email', 'required')">
                Field is Required
              </mat-error>
              <mat-error *ngIf="hasError('email', 'pattern')"
              >Invalid Format
              </mat-error
              >
              <mat-error *ngIf="hasError('email', 'emailError')">
                 {{ egacCreateForm.controls['email'].errors['emailError'] }}
              </mat-error>
              <mat-error
                *ngIf="egacCreateForm.get('email').errors?.serverError"
              >
                {{ egacCreateForm.get('email').errors?.serverError }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-12">
            <div *ngIf="data.userType == this.userTypeTokens.cabUser" class="title">Entity</div>
          </div>
          <div [hidden]="data.userType !== this.userTypeTokens.cabUser" class="col-sm-12">
            <mat-form-field appearance="outline" class="form-group">
              <mat-label>Entity Name [In English]</mat-label>
              <input
                [required]="data.userType == this.userTypeTokens.cabUser"
                formControlName="cabNameEnglish"
                matInput
                maxlength="500"
              />
              <mat-error *ngIf="hasError('cabNameEnglish', 'required')">
                Field in English is required
              </mat-error>
              <mat-error *ngIf="hasError('cabNameEnglish', 'pattern')">
                Field in English accept only English Letters,Numbers and Spaces
              </mat-error>
              <mat-error
                *ngIf="egacCreateForm.get('cabNameEnglish').errors?.serverError"
              >
                {{ egacCreateForm.get('cabNameEnglish').errors?.serverError }}
              </mat-error>
              <mat-error
                *ngIf="
                  egacCreateForm.get('cabNameEnglish').errors
                    ?.whiteSpaceValidator
                "
              >
                Field is Required
              </mat-error>
            </mat-form-field>
          </div>
          <!-- Entity Name (Arabic) Removed as per eng/Eslam -->
          <!-- <div [hidden]="data.userType !== this.userTypeTokens.cabUser" class="col-sm-12">
            <mat-form-field appearance="outline" class="form-group">
              <mat-label>Entity Name [In Arabic]</mat-label>
              <input
                [required]="data.userType == this.userTypeTokens.cabUser"
                formControlName="cabNameArabic"
                matInput
                maxlength="200"
              />
              <mat-error *ngIf="hasError('cabNameArabic', 'required')">
                Field in Arabic is required
              </mat-error>
              <mat-error *ngIf="hasError('cabNameArabic', 'pattern')">
                Field in Arabic accept only Arabic Letters,Numbers and Spaces
              </mat-error>
              <mat-error
                *ngIf="egacCreateForm.get('cabNameArabic').errors?.serverError"
              >
                {{ egacCreateForm.get('cabNameArabic').errors?.serverError }}
              </mat-error>
              <mat-error
                *ngIf="
                  egacCreateForm.get('cabNameArabic').errors
                    ?.whiteSpaceValidator
                "
              >
                Field is Required
              </mat-error>
            </mat-form-field>
          </div> -->
          <div class="col-sm-12">
            <div class="btn-container">
              <button
                [class.loading]="loading"
                [disabled]="!egacCreateForm.valid && !loading"
                class="btn-lg w-100"
                class="btn-create w-100"
                color="primary"
                mat-raised-button
              >
                <span>Create Account</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </mat-dialog-content>
</section>
